<div class="data-table-wrapper">
  <!-- Main Container - shows table, empty state, or loading -->
  <div class="table-container" [class.loading-state]="isLoading && !hasData" [style.height]="density === 'compact' ? 'auto' : tableHeight">
    <ng-template #tableCell let-column="column" let-row="row">
      <ng-container *ngIf="isSavingCell(row, column.key); else editableContent">
        <div class="inline-edit-saving">
          <mat-spinner diameter="18"></mat-spinner>
        </div>
      </ng-container>

      <ng-template #editableContent>
        <ng-container *ngIf="isEditingCell(row, column.key); else readContent">
          <span style="visibility: hidden;" aria-hidden="true">
            <ng-container *ngTemplateOutlet="cellTemplate; context: { column: column.key, row: row, view: 'table' }"></ng-container>
          </span>

          <ng-container [ngSwitch]="column.editType || 'text'">
            <select
              *ngSwitchCase="'select'"
              class="inline-edit-control"
              [value]="editingValue"
              (change)="setEditingValue($any($event.target).value)"
              (click)="$event.stopPropagation()"
              (keydown.enter)="commitCellEdit($event)"
              (keydown.escape)="cancelCellEdit($event)"
              (blur)="commitCellEdit($event)"
              autofocus>
              <option
                *ngFor="let option of column.editOptions ?? []"
                [value]="option.value"
                [selected]="isEditOptionSelected(option.value)">
                {{ option.label }}
              </option>
            </select>

            <div
              *ngSwitchCase="'multiSelect'"
              class="inline-edit-popover inline-edit-multiselect"
              tabindex="0"
              (click)="$event.stopPropagation()"
              (keydown.enter)="commitCellEdit($event)"
              (keydown.escape)="cancelCellEdit($event)">
              <div class="inline-edit-popover-title">{{ column.header }}</div>
              <div class="inline-edit-options">
                <label class="inline-edit-option" *ngFor="let option of column.editOptions ?? []">
                  <input
                    type="checkbox"
                    [checked]="isEditOptionSelected(option.value)"
                    (change)="setMultiEditingValue(option.value, $any($event.target).checked)" />
                  <span>{{ option.label }}</span>
                </label>
              </div>
              <div class="inline-edit-actions">
                <button type="button" class="inline-edit-secondary" (click)="cancelCellEdit($event)">Cancelar</button>
                <button type="button" class="inline-edit-primary" (click)="commitCellEdit($event)">Guardar</button>
              </div>
            </div>

            <input
              *ngSwitchCase="'number'"
              class="inline-edit-control"
              type="number"
              [value]="editingValue"
              (input)="setEditingValue($any($event.target).value)"
              (click)="$event.stopPropagation()"
              (keydown.enter)="commitCellEdit($event)"
              (keydown.escape)="cancelCellEdit($event)"
              (blur)="commitCellEdit($event)"
              autofocus />

            <input
              *ngSwitchCase="'date'"
              class="inline-edit-control"
              type="date"
              [value]="editingValue"
              (input)="setEditingValue($any($event.target).value)"
              (click)="$event.stopPropagation()"
              (keydown.enter)="commitCellEdit($event)"
              (keydown.escape)="cancelCellEdit($event)"
              (blur)="commitCellEdit($event)"
              autofocus />

            <input
              *ngSwitchDefault
              class="inline-edit-control"
              type="text"
              [value]="editingValue"
              (input)="setEditingValue($any($event.target).value)"
              (click)="$event.stopPropagation()"
              (keydown.enter)="commitCellEdit($event)"
              (keydown.escape)="cancelCellEdit($event)"
              (blur)="commitCellEdit($event)"
              autofocus />
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template #readContent>
        <ng-container *ngTemplateOutlet="cellTemplate; context: { column: column.key, row: row, view: 'table' }"></ng-container>
      </ng-template>
    </ng-template>

    <!-- Table WITH DRAG & DROP -->
    <table
      *ngIf="hasData && enableDragDrop"
      mat-table
      [dataSource]="dataSource"
      [multiTemplateDataRows]="!!rowDetailTemplate"
      class="data-table"
      [ngClass]="densityClass"
      [class.hoverable]="enableRowHover"
      [class.draggable]="enableDragDrop"
      [class.loading]="isLoading"
      cdkDropList
      [cdkDropListData]="dataSource.data"
      (cdkDropListDropped)="onRowDrop($event)">

      <ng-container matColumnDef="rowNumber">
        <th mat-header-cell *matHeaderCellDef class="row-number-cell">N.º</th>
        <td mat-cell *matCellDef="let row; let i = index; let dataRowIndex = dataIndex" class="row-number-cell">{{ getRowNumber(dataRowIndex ?? i) }}</td>
      </ng-container>

      <ng-container *ngFor="let column of localColumns" [matColumnDef]="column.key">
        <th mat-header-cell *matHeaderCellDef
          [attr.data-col]="column.key"
          [style.width]="column.width"
          [style.min-width]="column.minWidth"
          [class.sortable]="enableHeaderSort && column.sortable"
          [class.sorted]="column.sortable && getSortIcon(column)"
          (click)="onHeaderClick(column, $event)">
          <div class="header-content">
            <ng-container *ngIf="headerTemplate; else defaultHeader">
              <ng-container *ngTemplateOutlet="headerTemplate; context: { column: column.key, header: column.header }"></ng-container>
            </ng-container>
            <ng-template #defaultHeader><span>{{ column.header }}</span></ng-template>
            <span class="sort-badge" *ngIf="getSortIndex(column) >= 0">{{ getSortIndex(column) + 1 }}</span>
            <mat-icon *ngIf="getSortIcon(column)" class="sort-icon">{{ getSortIcon(column) }}</mat-icon>
          </div>
          <div *ngIf="column.resizable" class="resize-handle" (mousedown)="onResizeMouseDown($event, column.key)"></div>
        </th>
        <td mat-cell *matCellDef="let row"
          [style.width]="column.width"
          [class.editable-cell]="isCellEditable(column)"
          [class.editing-cell]="isEditingCell(row, column.key)"
          [class.saving-cell]="isSavingCell(row, column.key)"
          (click)="onCellClick($event, row, column)">
          <ng-container *ngTemplateOutlet="tableCell; context: { column: column, row: row }"></ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="rowDetail">
        <td mat-cell *matCellDef="let row" class="detail-cell" [attr.colspan]="displayedColumns.length">
          <ng-container *ngIf="row === expandedRow">
            <ng-container *ngTemplateOutlet="rowDetailTemplate; context: { row: row, view: 'table' }"></ng-container>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        (click)="onRowClick(row)"
        [class.hidden]="isLoading"
        cdkDrag [cdkDragData]="row" [cdkDragDisabled]="isLoading || editingCell !== null"
        class="data-row">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['rowDetail']; when: hasDetailTemplate"
        class="detail-row" [hidden]="row !== expandedRow || isLoading"></tr>
    </table>

    <!-- Table WITHOUT DRAG & DROP -->
    <table
      *ngIf="hasData && !enableDragDrop"
      mat-table
      [dataSource]="dataSource"
      [multiTemplateDataRows]="!!rowDetailTemplate"
      class="data-table"
      [ngClass]="densityClass"
      [class.hoverable]="enableRowHover"
      [class.loading]="isLoading">

      <ng-container matColumnDef="rowNumber">
        <th mat-header-cell *matHeaderCellDef class="row-number-cell">N.º</th>
        <td mat-cell *matCellDef="let row; let i = index; let dataRowIndex = dataIndex" class="row-number-cell">{{ getRowNumber(dataRowIndex ?? i) }}</td>
      </ng-container>

      <ng-container *ngFor="let column of localColumns" [matColumnDef]="column.key">
        <th mat-header-cell *matHeaderCellDef
          [attr.data-col]="column.key"
          [style.width]="column.width"
          [style.min-width]="column.minWidth"
          [class.sortable]="enableHeaderSort && column.sortable"
          [class.sorted]="column.sortable && getSortIcon(column)"
          (click)="onHeaderClick(column, $event)">
          <div class="header-content">
            <ng-container *ngIf="headerTemplate; else defaultHeader">
              <ng-container *ngTemplateOutlet="headerTemplate; context: { column: column.key, header: column.header }"></ng-container>
            </ng-container>
            <ng-template #defaultHeader><span>{{ column.header }}</span></ng-template>
            <span class="sort-badge" *ngIf="getSortIndex(column) >= 0">{{ getSortIndex(column) + 1 }}</span>
            <mat-icon *ngIf="getSortIcon(column)" class="sort-icon">{{ getSortIcon(column) }}</mat-icon>
          </div>
          <div *ngIf="column.resizable" class="resize-handle" (mousedown)="onResizeMouseDown($event, column.key)"></div>
        </th>
        <td mat-cell *matCellDef="let row"
          [style.width]="column.width"
          [class.editable-cell]="isCellEditable(column)"
          [class.editing-cell]="isEditingCell(row, column.key)"
          [class.saving-cell]="isSavingCell(row, column.key)"
          (click)="onCellClick($event, row, column)">
          <ng-container *ngTemplateOutlet="tableCell; context: { column: column, row: row }"></ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="rowDetail">
        <td mat-cell *matCellDef="let row" class="detail-cell" [attr.colspan]="displayedColumns.length">
          <ng-container *ngIf="row === expandedRow">
            <ng-container *ngTemplateOutlet="rowDetailTemplate; context: { row: row, view: 'table' }"></ng-container>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        (click)="onRowClick(row)"
        [class.hidden]="isLoading"
        class="data-row">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['rowDetail']; when: hasDetailTemplate"
        class="detail-row" [hidden]="row !== expandedRow || isLoading"></tr>
    </table>

    <app-empty-state
      *ngIf="!isLoading && hasData === false"
      icon="inbox"
      [title]="noDataMessage"
      description="No hay registros que mostrar en este momento">
    </app-empty-state>

    <app-loading-state
      *ngIf="isLoading && !hasData"
      message="Obteniendo datos..."
      [spinnerDiameter]="50">
    </app-loading-state>

    <mat-progress-bar
      *ngIf="isLoading && hasData"
      mode="indeterminate"
      class="table-progress-bar">
    </mat-progress-bar>
  </div>

  <app-data-pagination *ngIf="!errorMessage && paginationConfig"
    [paginationConfig]="paginationConfig" [isLoading]="isLoading"
    [showPageSizeSelector]="showPageSizeSelector" [pageSizeOptions]="pageSizeOptions"
    (pageChange)="pageChange.emit($event)" (pageSizeChange)="pageSizeChange.emit($event)" />
</div>
